import moment from 'moment';

export function formatDate(date: moment.Moment | Date | string, withTime?: boolean) {
  date = moment(date);
  return date.format(
    date.year() === moment().year() ? (withTime ? 'D MMM HH:mm' : 'D MMM') : 'D MMM YY'
  );
}
